import axios, {AxiosResponse} from 'axios';

import {
    UserListFilterParams,
    UsersPayload,
    UserOption,
    UserEditParams,
    UserAddParams,
} from '@pluto/users';
import {formQuery} from './form-query';

export const getUsers = async (params: UserListFilterParams) => {
    const query = formQuery('/api/users', params);
    const {data}: AxiosResponse<UsersPayload> = await axios(query);
    
    return data;
};

export const getUser = async (id: number) => {
    const {data} = await axios(`/api/users/${id}`);
    
    return data;
};

export const getUserData = async () => {
    const {data}: AxiosResponse<UserOption> = await axios('/api/users/me');
    
    return data;
};

export const addUser = async (params: UserAddParams) => {
    const {body} = params;
    
    return await axios.post(
        '/api/users',
        body,
    );
};

export const editUser = async (params: UserEditParams) => {
    const {id, body} = params;
    
    return await axios.put(
        `/api/users/${id}`,
        body,
    );
};
